export type MenuItem = {
  id: string;
  to: string;
  title: string;
  pet?: boolean;
  icon: string;
  iconActive?: string;
  type?: 'internal' | 'external';
  requiredTags?: string[];
  excludedTags?: string[];
  hasDiscountIcon?: boolean;
};

// Text of the badge drawn next to any item with `hasDiscountIcon`. Shared by the
// desktop sidebar (AsideMenuItem) and the mobile bottom nav (MenuMobileItem) so
// the two cannot drift apart.
//
// Not a translated message on purpose: all three catalogues would hold the same
// "-20%", and the i18n checker has no way to tell a stale percentage from a
// current one. `ShopPage`'s product-card badge still has its own copy of this
// number — if the campaign stops being a flat 20% off, both should read it from
// the campaign or product data instead of being hand-edited.
export const MENU_DISCOUNT_BADGE_LABEL = '-20%';

// The route that signs the customer out. Shared by the profile menu's logout
// link and the Mahlzeiten page's unsaved-changes guard, which lets it through.
export const LOGOUT_PATH = '/logout';

export const MENU_ITEMS: MenuItem[] = [
  {
    id: 'dashboard',
    to: '/dashboard',
    title: 'MENU.DASHBOARD',
    icon: '/media/svg/aside/overview_nav_icon.svg',
    iconActive: '/media/svg/aside/overview_nav_icon_active.svg',
  },
  {
    id: 'orders',
    to: '/orders',
    title: 'MENU.ORDERS',
    icon: '/media/svg/aside/orders_nav_icon.svg',
    iconActive: '/media/svg/aside/orders_nav_icon_active.svg',
  },
  {
    id: 'subscriptions',
    to: '/subscriptions',
    title: 'MENU.SUBSCRIPTIONS',
    pet: true,
    icon: '/media/svg/aside/mahlzeiten_nav_icon.svg',
    iconActive: '/media/svg/aside/mahlzeiten_nav_icon_active.svg',
  },
  {
    id: 'raf',
    to: '/raf',
    title: 'MENU.FREUNDE',
    icon: '/media/svg/aside/raf_nav_icon.svg',
    iconActive: '/media/svg/aside/raf_nav_icon_active.svg',
  },
  {
    id: 'shop',
    to: '/mitbestellen',
    title: 'MENU.SHOP',
    icon: '/media/svg/aside/shop_nav_icon.svg',
    iconActive: '/media/svg/aside/shop_nav_icon_active.svg',
    hasDiscountIcon: true,
  },
  // {
  //   id: 'store-credit',
  //   to: '/store-credit',
  //   title: 'MENU.PFOTENPUNKTE',
  //   icon: '/media/svg/aside/shop_nav_icon.svg',
  //   iconActive: '/media/svg/aside/shop_nav_icon_active.svg',
  // },
];

export const NAVI: MenuItem[] = [
  ...MENU_ITEMS,
  {
    id: 'profile',
    to: '/profile',
    title: 'MENU.PROFILE',
    icon: '/media/svg/aside/paw.svg',
  },
  {
    id: 'faq',
    to: 'https://www.hellobello.de/pages/help-center',
    title: 'MENU.FAQ',
    icon: '/media/svg/general/question-mark-green.svg',
    type: 'external',
  },
];

export const PROFILE_MENU_ITEMS: MenuItem[] = [
  {
    id: 'profile',
    to: '/profile',
    title: 'MENU.KONTODETAILS',
    icon: '/media/svg/header/profile_nav_icon.svg',
  },
  {
    id: 'contact',
    to: 'https://www.hellobello.de/pages/kontakt',
    title: 'AUTH.GENERAL.CONTACT',
    icon: '/media/svg/header/contact_nav_icon.svg',
    type: 'external',
  },
  {
    id: 'faq',
    to: 'https://www.hellobello.de/pages/hellobello-help-center',
    title: 'MENU.FAQ',
    icon: '/media/svg/header/faq_nav_icon.svg',
    type: 'external',
  },
  {
    id: 'logout',
    to: LOGOUT_PATH,
    title: 'AUTH.GENERAL.LOGOUT',
    icon: '/media/svg/header/logout_nav_icon.svg',
  },
];
